import type { RegulatoryDocumentResponse } from '@/@types/Products';
import { convertBytesToMB } from '@/lib/select-options';

export function getRegulatoryDocumentDisplayName(
  doc: RegulatoryDocumentResponse,
): string {
  return (
    doc.document_name?.trim() ||
    doc.file?.original_name?.trim() ||
    doc.file?.name ||
    '—'
  );
}

export function getRegulatoryDocumentSizeLabel(
  doc: RegulatoryDocumentResponse,
): string {
  if (doc.file?.size_formatted) return doc.file.size_formatted;
  if (doc.file?.size != null) return `${convertBytesToMB(doc.file.size)} MB`;
  return '—';
}

export function getRegulatoryDocumentFileUrl(
  doc: RegulatoryDocumentResponse,
): string | undefined {
  return doc.file?.url;
}

export function mapRegulatoryDocumentBadgeStatus(status: string): string {
  switch (status) {
    case 'analyzing':
      return 'analysis';
    case 'approved':
      return 'active';
    case 'rejected':
      return 'rejected';
    case 'disapproved':
      return 'disapproved';
    default:
      return 'pending';
  }
}

/** Maps API status values to i18n key suffixes under `regulatoryDocumentStatus_*`. */
export function getRegulatoryDocumentStatusTranslationKey(
  status: string,
): 'analysis' | 'approved' | 'disapproved' {
  switch (status) {
    case 'analyzing':
    case 'analysis':
      return 'analysis';
    case 'approved':
      return 'approved';
    case 'rejected':
    case 'disapproved':
      return 'disapproved';
    default:
      return 'analysis';
  }
}
